import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = {role: ROLE.SUPER_ADMIN};

const path = "admin/puja-booking"

export const BookingList = async (values) => {
    return await axiosInstance(options).post(`${path}/list`, values);
}
export const AssignAstrologer = async (values) => {
    return await axiosInstance(options).post(`${path}/assign-astrologer`, values);
}

export const UpdateStatus = async (values) => {
    return await axiosInstance(options).post(`${path}/update-status`, values);
}